module.exports = __webpack_public_path__ + "images/common/item_watch_recommendation_img_01_f7342eef53799a563c82a692e13a1a23.png";